(() => {
  if (window.__StIncInit) return;

  const euro  = c => (Math.max(0,c|0)/100).toFixed(2).replace('.',',')+'\u00a0\u20ac';
  const clamp = (v,thr) => { if(!thr) return 0; let p=(v/thr)*100; if(v>0&&p<1)p=1; return Math.min(100,Math.round(p)); };
  const grad  = (color,pct) => `linear-gradient(to right,${color} 0%,${color} ${pct}%,rgba(60,66,74,0.12) ${pct}%,rgba(60,66,74,0.12) 100%)`;

  const SVG = {
    check:   '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    truck:   '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    gift:    '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    checkSm: '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    truckSm: '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    giftSm:  '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>'
  };

  let _product = null;

  function calcQualifying(root, items) {
    const mode      = root.dataset.promoMode || 'tag';
    const tag       = root.dataset.qualifyingTag || '';
    const variantId = parseInt(root.dataset.qualifyingVariantId||'0',10);
    return items.reduce((sum, item) => {
      if (item.properties && item.properties._free_gift === 'promo_gift') return sum;
      let q = false;
      if (mode === 'tag') {
        q = !tag;
        if (!q && item.product_tags) q = item.product_tags.includes(tag);
        if (!q && item.tags) q = item.tags.includes(tag);
      } else if (mode === 'variant') {
        q = variantId > 0 && item.variant_id === variantId;
      }
      return q ? sum + (item.final_line_price || item.original_line_price || 0) : sum;
    }, 0);
  }

  function updateUI(root, cart) {
    const shipThr  = parseInt(root.dataset.shipThreshold||'0',10);
    const giftThr  = parseInt(root.dataset.giftThreshold||'0',10);
    const giftOn   = root.dataset.giftEnabled === 'true';
    const shipFirst= root.dataset.shipFirst !== 'false';
    const gTitle   = root.dataset.giftTitle || 'Gratisartikel';
    const items    = cart.items || [];
    const total    = cart.total_price || 0;
    const qualifying = giftOn ? calcQualifying(root, items) : 0;

    const shipOk     = shipThr > 0 && total >= shipThr;
    const giftOk     = giftOn && giftThr > 0 && qualifying >= giftThr;
    const giftInCart = giftOn && items.some(i => i.properties && i.properties._free_gift === 'promo_gift');

    const lineA  = root.querySelector('#st-line-a');
    const lineB  = root.querySelector('#st-line-b');
    const nodeA  = root.querySelector('#st-node-a');
    const nodeB  = root.querySelector('#st-node-b');
    const status = root.querySelector('#st-status-text');
    const btnEl  = root.querySelector('#st-gift-open');
    const doneEl = root.querySelector('#st-gift-done');
    const lblA   = root.querySelector('#st-label-a');
    const lblB   = root.querySelector('#st-label-b');

    if (lineA && lineB && nodeA && nodeB) {
      const typeA = shipFirst ? 'ship' : 'gift';
      const typeB = shipFirst ? 'gift' : 'ship';
      const thrA  = shipFirst ? shipThr : giftThr;
      const thrB  = shipFirst ? giftThr : shipThr;
      const valA  = typeA === 'ship' ? total : qualifying;
      const valB  = typeB === 'ship' ? total : qualifying;
      const doneA = thrA > 0 && valA >= thrA;
      const doneB = thrB > 0 && valB >= thrB;

      const pctA   = clamp(valA, thrA);
      const pctB   = doneA && thrB > thrA ? clamp(Math.max(0, valB - thrA), thrB - thrA) : 0;
      const colorA = typeA === 'gift' ? '#d73251' : '#3c424a';
      const colorB = typeB === 'gift' ? '#d73251' : '#3c424a';
      const doneColorA = '#639922';
      const doneColorB = '#639922';

      lineA.style.background = doneA ? doneColorA : grad(colorA, pctA);
      lineB.style.background = doneB ? doneColorB : grad(colorB, pctB);

      if (typeA === 'ship') {
        nodeA.className = 'st-inc__node ' + (doneA ? 'st-inc__node--ship-done' : 'st-inc__node--ship-next');
        nodeA.innerHTML = doneA ? SVG.check : SVG.truck;
      } else {
        nodeA.className = 'st-inc__node ' + (giftInCart ? 'st-inc__node--gift-done' : doneA ? 'st-inc__node--gift-ready' : 'st-inc__node--gift-next');
        nodeA.innerHTML = (giftInCart || doneA) ? SVG.check : SVG.gift;
      }

      if (typeB === 'ship') {
        nodeB.className = 'st-inc__node ' + (doneB ? 'st-inc__node--ship-done' : 'st-inc__node--ship-next');
        nodeB.innerHTML = doneB ? SVG.check : SVG.truck;
      } else {
        nodeB.className = 'st-inc__node ' + (giftInCart ? 'st-inc__node--gift-done' : doneB ? 'st-inc__node--gift-ready' : 'st-inc__node--gift-next');
        nodeB.innerHTML = (giftInCart || doneB) ? SVG.check : SVG.gift;
      }

      if (lblA) lblA.className = 'st-inc__step-label' + (doneA ? ' st-inc__step-label--done' : typeA==='gift'&&giftOk ? ' st-inc__step-label--ready' : '');
      if (lblB) lblB.className = 'st-inc__step-label' + (doneB ? ' st-inc__step-label--done' : typeB==='gift'&&giftOk ? ' st-inc__step-label--ready' : '');

      if (status) {
        const shipRem = Math.max(0, shipThr - total);
        const giftRem = Math.max(0, giftThr - qualifying);
        if (giftInCart) {
          status.className = 'st-inc__status-text st-inc__status-text--ok';
          status.innerHTML = '<strong>' + gTitle + '</strong> liegt im Warenkorb.';
        } else if (giftOk) {
          status.className = 'st-inc__status-text st-inc__status-text--gift';
          status.innerHTML = '<strong>' + gTitle + '</strong> verf\u00fcgbar \u2013 jetzt aussuchen!';
        } else if (shipOk && !giftOk) {
          status.className = 'st-inc__status-text';
          status.innerHTML = 'Gratis-Versand erzielt! Noch <strong>' + euro(giftRem) + '</strong> bis ' + gTitle + '.';
        } else if (doneA) {
          status.className = 'st-inc__status-text';
          const nr = typeB==='gift' ? giftRem : shipRem;
          const nl = typeB==='gift' ? gTitle  : 'Gratis-Versand';
          status.innerHTML = 'Noch <strong>' + euro(nr) + '</strong> bis ' + nl + '.';
        } else {
          status.className = 'st-inc__status-text';
          const fr = typeA==='gift' ? giftRem : shipRem;
          const fl = typeA==='gift' ? gTitle  : 'Gratis-Versand';
          status.innerHTML = 'Noch <strong>' + euro(fr) + '</strong> bis ' + fl + '.';
        }
      }

      if (btnEl)  btnEl.style.display  = (giftOk && !giftInCart) ? '' : 'none';
      if (doneEl) doneEl.style.display = 'none';
    }

    const singleTrack = root.querySelector('.st-inc__single #st-ship-track');
    if (singleTrack) {
      const pct = clamp(total, shipThr);
      singleTrack.style.background = shipOk ? '#639922' : grad('#3c424a', pct);
      const msg  = root.querySelector('#st-ship-msg');
      const txt  = root.querySelector('#st-ship-text');
      const icon = root.querySelector('#st-ship-icon');
      if (msg)  msg.className = 'st-inc__msg' + (shipOk ? ' st-inc__msg--success' : '');
      if (txt)  txt.textContent = shipOk
        ? (root.dataset.shipTxtOk||'')
        : (root.dataset.shipTxtRem||'').replace('[[amount]]', euro(Math.max(0,shipThr-total)));
      if (icon) {
        icon.className = 'st-inc__end-icon' + (shipOk ? ' st-inc__end-icon--done' : '');
        icon.innerHTML = shipOk ? SVG.checkSm : SVG.truckSm;
      }
    }

    const giftTrack = root.querySelector('#st-gift-track');
    if (giftTrack) {
      const done = giftOk || giftInCart;
      const pct  = clamp(qualifying, giftThr);
      giftTrack.style.background = done ? '#639922' : grad('#d73251', pct);
      const gicon = root.querySelector('#st-gift-icon');
      if (gicon) {
        gicon.className = 'st-inc__end-icon' + (done ? ' st-inc__end-icon--done' : '');
        gicon.innerHTML = done ? SVG.checkSm : SVG.giftSm;
      }
      const gstatus = root.querySelector('#st-status-text');
      if (gstatus) {
        const giftRem = Math.max(0, giftThr - qualifying);
        if (giftInCart) {
          gstatus.className = 'st-inc__status-text st-inc__status-text--ok';
          gstatus.innerHTML = '<strong>' + gTitle + '</strong> liegt im Warenkorb.';
        } else if (giftOk) {
          gstatus.className = 'st-inc__status-text st-inc__status-text--gift';
          gstatus.innerHTML = '<strong>' + gTitle + '</strong> verf\u00fcgbar \u2013 jetzt aussuchen!';
        } else {
          gstatus.className = 'st-inc__status-text';
          gstatus.innerHTML = 'Noch <strong>' + euro(giftRem) + '</strong> bis ' + gTitle + '.';
        }
      }
      const gbtn  = root.querySelector('#st-gift-open');
      const gdone = root.querySelector('#st-gift-done');
      if (gbtn)  gbtn.style.display  = (giftOk && !giftInCart) ? '' : 'none';
      if (gdone) gdone.style.display = 'none';
    }
  }

  let lastFetch = 0;
  function refresh() {
    const now = Date.now();
    if (now - lastFetch < 120) return;
    lastFetch = now;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(cart => document.querySelectorAll('#st-incentives').forEach(r => updateUI(r, cart)))
      .catch(() => {});
  }

  /* Global sofort verfügbar machen – BEVOR alles andere */
  window.__StIncRefresh = refresh;
  window.__StIncInit    = true;

  /* MutationObserver – feuert wenn #st-incentives ins DOM kommt */
  const _obs = new MutationObserver(() => {
    if (document.querySelector('#st-incentives')) refresh();
  });
  _obs.observe(document.body, { childList: true, subtree: true });

  refresh();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  setTimeout(refresh, 300);
  setTimeout(refresh, 800);

  ['cart:refresh','cart:updated'].forEach(e => document.addEventListener(e, refresh));
  document.addEventListener('cart:open', () => setTimeout(refresh, 50));
  window.addEventListener('sterntaler-cart-update', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('change', e => { if (e.target?.classList?.contains('quantity__input')) setTimeout(refresh, 80); });
  document.addEventListener('click', e => {
    if (e.target.closest('.cart-remove-button,[data-cart-remove],[data-remove],button[name="remove"]')) setTimeout(refresh, 120);
  });
  document.addEventListener('submit', e => {
    const f = e.target; if (!(f instanceof HTMLFormElement)) return;
    const a = f.getAttribute('action') || f.action || '';
    if (a.includes('/cart/add')) { setTimeout(refresh, 250); setTimeout(refresh, 800); }
  });
  try {
    const oF = window.fetch;
    window.fetch = function(input) {
      let url = ''; try { url = (typeof input==='string' ? input : input.url) || ''; } catch(_) {}
      const p = oF.apply(this, arguments);
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
        p.finally(() => { setTimeout(refresh, 80); setTimeout(refresh, 400); });
      return p;
    };
  } catch(_) {}
  try {
    const OX = window.XMLHttpRequest;
    function WX() {
      const x = new OX(); let _u = '';
      x.open = (function(o) { return function(m,u) { _u = String(u||''); return o.apply(x,arguments); }; })(x.open);
      x.addEventListener('loadend', () => {
        if (_u.includes('/cart/add') || _u.includes('/cart/change') || _u.includes('/cart/update'))
          { setTimeout(refresh,80); setTimeout(refresh,400); }
      });
      return x;
    }
    window.XMLHttpRequest = WX;
  } catch(_) {}

  /* ── Modal ── */
  async function loadProduct(handle) {
    if (_product) return _product;
    if (!handle) throw new Error('no handle');
    const r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    const p = await r.json();
    p.availableVariants = (p.variants || []).filter(v => !!v.available);
    _product = p; return p;
  }
  const getColors = p => { const c=[]; (p.availableVariants||[]).forEach(v => { if(v.option1&&!c.includes(v.option1)) c.push(v.option1); }); return c; };
  const getSizes  = (p,col) => { const s=[]; (p.availableVariants||[]).forEach(v => { if(v.option1===col&&v.option2&&!s.includes(v.option2)) s.push(v.option2); }); return s; };
  const getImg    = v => { if(!v) return ''; if(v.featured_image&&typeof v.featured_image==='object') return v.featured_image.src||''; if(typeof v.featured_image==='string') return v.featured_image; return v.featured_media?.preview_image?.src||''; };
  const selColor = () => document.querySelector('.pg-color-card.is-active')?.dataset.color || '';
  const selSize  = () => document.querySelector('.pg-size-pill.is-active')?.dataset.size || '';
  const findVar  = () => {
    if (!_product) return null;
    const c = selColor(), s = selSize();
    return (_product.availableVariants||[]).find(v => v.option1===c && v.option2===s) || null;
  };

  function updateHero(color) {
    const hero = document.querySelector('#pg-modal-hero');
    const placeholder = document.querySelector('#pg-modal-hero-placeholder');
    if (!hero || !_product) return;
    const ref = (_product.availableVariants||[]).find(v => v.option1===color) || null;
    const src = getImg(ref);
    let existing = hero.querySelector('.pg-modal__hero-img');
    if (src) {
      if (existing) { existing.src = src; }
      else {
        const img = document.createElement('img');
        img.className = 'pg-modal__hero-img';
        img.src = src; img.alt = color; img.loading = 'lazy';
        hero.insertBefore(img, hero.firstChild);
      }
      if (placeholder) placeholder.style.display = 'none';
    } else {
      if (existing) existing.remove();
      if (placeholder) placeholder.style.display = '';
    }
  }

  function updateProductValue() {
    const el = document.querySelector('#pg-modal-value');
    if (!el || !_product) return;
    const prices = (_product.variants||[]).map(v => v.compare_at_price || v.price).filter(Boolean);
    if (!prices.length) { el.textContent = ''; return; }
    const maxPrice = Math.max(...prices);
    if (maxPrice > 0) {
      const fmt = (maxPrice/100).toFixed(2).replace('.',',') + ' €';
      el.textContent = 'Wert: ' + fmt + ' – für dich gratis!';
    }
  }

  function renderSizes(color) {
    const wrap = document.querySelector('#pg-size-options');
    if (!wrap || !_product) return;
    const prevSize = selSize();
    wrap.innerHTML = '';
    const availSizes = getSizes(_product, color);
    const allSizes = [];
    (_product.variants||[]).forEach(v => { if(v.option1===color && v.option2 && !allSizes.includes(v.option2)) allSizes.push(v.option2); });
    allSizes.forEach((size, i) => {
      const avail = availSizes.includes(size);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.dataset.size = size;
      btn.className = 'pg-size-pill' + (!avail ? ' is-unavailable' : '');
      if (avail && (prevSize === size || (!prevSize && i === 0))) btn.classList.add('is-active');
      btn.textContent = size;
      if (!avail) btn.disabled = true;
      wrap.appendChild(btn);
    });
    if (!wrap.querySelector('.pg-size-pill.is-active')) {
      const first = wrap.querySelector('.pg-size-pill:not(.is-unavailable)');
      if (first) first.classList.add('is-active');
    }
  }

  function updateModalStatus() {
    const st  = document.querySelector('#pg-variant-status');
    const btn = document.querySelector('#pg-add-btn');
    if (!st || !btn) return;
    if (!_product?.availableVariants?.length) { st.textContent='Aktuell nicht verfügbar.'; btn.disabled=true; return; }
    renderSizes(selColor());
    const v = findVar();
    if (!v) { st.className='pg-variant-status'; st.textContent='Bitte wähle Farbe und Größe.'; btn.disabled=true; return; }
    st.className = 'pg-variant-status pg-variant-status--ok';
    st.textContent = 'Ausgewählt: ' + [v.option1, v.option2].filter(Boolean).join(' / ');
    btn.disabled = false;
  }

  function renderColors() {
    const wrap = document.querySelector('#pg-color-options'); if(!wrap||!_product) return;
    wrap.innerHTML = '';
    getColors(_product).forEach((color, i) => {
      const ref = (_product.availableVariants||[]).find(v=>v.option1===color) || null;
      const btn = document.createElement('button');
      btn.type='button'; btn.className='pg-color-card'+(i===0?' is-active':''); btn.dataset.color=color;
      const src = getImg(ref);
      if (src) { const img=document.createElement('img'); img.className='pg-color-card__image'; img.src=src; img.alt=color; img.loading='lazy'; btn.appendChild(img); }
      else { const ph=document.createElement('div'); ph.className='pg-color-card__placeholder'; ph.textContent=color.charAt(0).toUpperCase(); btn.appendChild(ph); }
      const lbl=document.createElement('span'); lbl.className='pg-color-card__label'; lbl.textContent=color; btn.appendChild(lbl);
      wrap.appendChild(btn);
    });
    const firstColor = getColors(_product)[0] || '';
    updateHero(firstColor);
    updateProductValue();
    updateModalStatus();
  }
  async function openModal() {
    const modal = document.querySelector('#pg-modal');
    const st    = document.querySelector('#pg-variant-status');
    const btn   = document.querySelector('#pg-add-btn');
    if (!modal) return;
    modal.hidden = false; document.body.classList.add('pg-modal-open');
    if (st) st.textContent='Lade Produkt…'; if (btn) btn.disabled=true;
    try {
      const handle = document.querySelector('#st-incentives')?.dataset.giftHandle || '';
      await loadProduct(handle);
      if (!_product?.availableVariants?.length) { if(st) st.textContent='Aktuell nicht verfügbar.'; return; }
      renderColors();
    } catch(e) { console.warn('[StInc]', e); if(st) st.textContent='Produkt konnte nicht geladen werden.'; }
  }
  function closeModal() {
    const m = document.querySelector('#pg-modal'); if(!m) return;
    m.hidden=true; document.body.classList.remove('pg-modal-open');
  }

  document.addEventListener('click', async e => {
    if (e.target.closest('#st-gift-open'))        { e.preventDefault(); await openModal(); return; }
    if (e.target.closest('.pg-modal__close') ||
        e.target.closest('.pg-modal__backdrop'))  { e.preventDefault(); closeModal(); return; }
    const cb = e.target.closest('.pg-color-card');
    if (cb) {
      e.preventDefault();
      document.querySelectorAll('.pg-color-card').forEach(b=>b.classList.remove('is-active'));
      cb.classList.add('is-active');
      updateHero(cb.dataset.color);
      updateModalStatus();
      return;
    }
    const sp = e.target.closest('.pg-size-pill');
    if (sp && !sp.disabled) {
      e.preventDefault();
      document.querySelectorAll('.pg-size-pill').forEach(b=>b.classList.remove('is-active'));
      sp.classList.add('is-active');
      updateModalStatus();
      return;
    }
    if (e.target.closest('#pg-add-btn')) {
      const st  = document.querySelector('#pg-variant-status');
      const btn = document.querySelector('#pg-add-btn');
      const v   = findVar(); if (!v) { updateModalStatus(); return; }
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({items:[{id:v.id,quantity:1,properties:{_free_gift:'promo_gift'}}]}) });
        if (!res.ok) throw new Error('Cart add failed');
        try { sessionStorage.setItem('reopenCartDrawer','1'); } catch(_) {}
        window.location.reload();
      } catch(e) { console.warn('[StInc]',e); btn.disabled=false; if(st) st.textContent='Konnte nicht hinzugefügt werden.'; }
    }
  });
  // size pills handled via click above
  document.addEventListener('keydown', e => { if (e.key==='Escape') closeModal(); });

  function openDrawer() {
    const d = document.querySelector('cart-drawer');
    if (d && typeof d.open==='function') { try { d.open(); return; } catch(_) {} }
    try { document.dispatchEvent(new CustomEvent('cart:open')); } catch(_) {}
    for (const s of ['#cart-icon-bubble a','#cart-icon-bubble button','button[aria-controls="CartDrawer"]','.header__icon--cart']) {
      const el = document.querySelector(s); if (el) { el.click(); return; }
    }
  }
  try {
    if (sessionStorage.getItem('reopenCartDrawer')==='1') {
      sessionStorage.removeItem('reopenCartDrawer');
      if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', openDrawer);
      else openDrawer();
    }
  } catch(_) {}
})();